<div
  cdkDropList
  class="drag-drop-container"
  [cdkDropListOrientation]="orientation()"
  [class]="containerClass()"
  (cdkDropListDropped)="onDrop($event)"
>
  @for (item of displayedItems; track trackByFn($index, item)) {
    <div cdkDrag [class]="itemClass()" class="drag-item">
      <ng-container
        *ngTemplateOutlet="itemTemplate(); context: { $implicit: item }"
      ></ng-container>
    </div>
  }
</div>
